import { get } from 'lodash';

export class BasicDetailsForm {
  public dob: { day?: string; month?: string; year?: string };
  public gender: string | undefined;
  constructor(initial: any) {
    this.dob = get(initial, 'dob', { day: undefined,  month: undefined, year: undefined });
    this.gender = get(initial, 'gender', undefined);
  }
}
